import React, { ReactElement } from 'react';
import { MediaMatch } from '@lamimed/pantheon';
import { NextPageContext } from 'next';

import { getAxiosError } from 'utils/getAxiosError';
import { axiosFactory } from 'utils/http/axiosFactory';
import { sendToErrorTracking } from 'utils/sendToErrorTracking';

import { ScheduleLayout } from 'layouts/schedule';

import ProductTemplate from 'templates/Product';
import { ProductProvider } from 'templates/Product/useProduct';

import { Footer } from 'components/Footer';

export default function ProductDetail() {
  return <ProductTemplate />;
}

ProductDetail.getLayout = function getLayout(page: ReactElement) {
  return (
    <ScheduleLayout>
      <ProductProvider>{page}</ProductProvider>

      <MediaMatch greaterThan="tablet">
        <Footer />
      </MediaMatch>
    </ScheduleLayout>
  );
};

/*
 * NOTE: This is needed to useRouter be able to hydrate on the first render, if we don't use this useRouter will return undefined on the first render and hydrate after
 * The first undefined is enough to break SWR so we're forcing this hydrate on the first render.
 */
export const getServerSideProps = async ({ query }: NextPageContext) => {
  try {
    const response = await axiosFactory().get(`/product/${query.slug}`);

    return {
      props: {
        fallback: {
          [`/product/${query.slug}`]: response.data,
        },
      },
    };
  } catch (error) {
    sendToErrorTracking({
      error,
      where: 'pages/category/slug/getServerSideProps',
      context: query,
    });

    if (getAxiosError(error).response?.status === 404)
      return {
        notFound: true,
      };
  }
};
